import { trackError } from 'utils/helpers';

const securePayment = (params) => {
  const apiPrefix = ecom.craftConfig.api_prefix;
  let url = '/secure-payment';

  if (apiPrefix) {
    url = `${apiPrefix}/secure-payment`;
  }

  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(params),
  })
    .then((response) => response.json())
    .then((json) => json)
    .catch((error) => {
      trackError(error);

      return {
        message: error.message,
      };
    });
};

export default securePayment;
